/** biome-ignore-all lint/style/useNamingConvention: legacy */
export const USER_STUDENT_FORM_ERRORS = {
  UPDATE_FORBIDDEN: 'UPDATE_FORBIDDEN',
} as const;

export const EMPLOYEES_ERRORS = {
  ADD: {
    DUPLICATE_DB: {
      MESSAGE: 'Error: User email already in database.',
      MORE: 'ADD_EMPLOYEE_EMAIL_IN_DB',
    },
    NOT_IN_GOOGLE: {
      MESSAGE: 'Error: Email address not existing at google.',
      MORE: 'ADD_EMPLOYEE_EMAIL_NOT_AT_GOOGLE',
    },
    ALREADY_IN_GOOGLE: {
      MESSAGE: 'Error: Email address already at google.',
      MORE: 'ADD_EMPLOYEE_EMAIL_ALREADY_AT_GOOGLE',
    },
    EMAIL_DUPLICATE: 'ADD_EMPLOYEE_DUPLICATE_EMAIL',
  },
} as const;

export const TUTOR_ERRORS = {
  ADD: {
    NOT_IN_GOOGLE: {
      MESSAGE: 'Error: Email address not existing at google.',
      MORE: 'ADD_TUTOR_EMAIL_NOT_AT_GOOGLE',
    },
  },
  STUDENT_WRONG_AFFECTATION: 'STUDENT_WRONG_AFFECTATION',
  STUDENT_ALREADY_TUTORED: 'STUDENT_ALREADY_TUTORED',
} as const;

export const STUDENTS_ERRORS = {
  ADD: {
    NOT_IN_GOOGLE: {
      MESSAGE: 'Error: Email address not existing at google.',
      MORE: 'ADD_STUDENT_EMAIL_NOT_AT_GOOGLE',
    },
    DUPLICATE_DB: {
      MESSAGE: 'Error: User email already in database.',
      MORE: 'ADD_STUDENT_EMAIL_IN_DB',
    },
    DUPLICATE_STUDENT_REF_DB: {
      MESSAGE: 'Error: User studentRef already in database.',
      MORE: 'ADD_STUDENT_REF_IN_DB',
    },
  },
  UPDATE: {
    OPTIONAL_LESSONS_FORBIDDEN: 'OPTIONAL_LESSONS_FORBIDDEN',
    NOT_IN_GOOGLE: {
      MESSAGE: 'Error: Email address not existing in google.',
      MORE: 'UPDATE_STUDENT_EMAIL_NOT_AT_GOOGLE',
    },
    DUPLICATE_DB: {
      MESSAGE: 'Error: User email already in database.',
      MORE: 'UPDATE_STUDENT_EMAIL_IN_DB',
    },
    DUPLICATE_COURSE: {
      MESSAGE: 'Error: Student is already enrolled in this course.',
      MORE: 'UPDATE_STUDENT_DUPLICATE_COURSE',
    },
    ACCESS_START_DATE: {
      IS_GREATER_THAN_TODAY: {
        MESSAGE: 'Error: The course is already accessible by the student.',
        MORE: 'UPDATE_ACCESS_START_DATE',
      },
    },
  },
  NOT_ACCESS_TO_LESSON: 'NOT_ACCESS_TO_LESSON',
  NOT_ACCESS_TO_LESSON_VERSION: 'NOT_ACCESS_TO_LESSON_VERSION',
  NOT_IN_COURSE: 'STUDENT_NOT_IN_COURSE',
  COURSE_NOT_LINKED_TO_TUTOR: 'COURSE_NOT_LINKED_TO_TUTOR',
  NOT_LINKED_TO_TUTOR: 'NOT_LINKED_TO_TUTOR',
} as const;

export const STUDENT_CARD_ERRORS = {
  USER_NOT_ELIGIBLE: 'USER_NOT_ELIGIBLE_FOR_STUDENT_CARD',
} as const;
